import { render } from "./PassingEditForm.vue?vue&type=template&id=f5325646&scoped=true"
import script from "./PassingEditForm.vue?vue&type=script&lang=js"
export * from "./PassingEditForm.vue?vue&type=script&lang=js"

import "./PassingEditForm.vue?vue&type=style&index=0&id=f5325646&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5325646"]])

export default __exports__